import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { startThumbnailFlow } from 'actions/editor';
import { CUSTOM_VIDEO_THUMBS, LOOM_PRO } from 'constants/capabilities';
import {
  CUSTOM_THUMBNAIL_CLICKED,
  SHARE_PAGE_EDITOR_FAB_PRO_UPSELL,
} from 'constants/events';
import { HELP_UPLOAD_THUMBNAIL } from 'constants/feature-tour';
import { removeVideoThumbnail } from 'creators/shareVideo';
import * as analytics from 'utilities/analytics';
import * as device from 'utilities/device';

import {
  OG_THUMB_FULL,
  THUMB_FULL,
} from '../../../../../shared/constants/video';

import ActionDot, { TOP_LEFT } from 'components/ui-components/action-dot';
import FabButton from 'components/ui-components/fab-button';

import './styles.less';

class CustomThumbnailButton extends React.Component {
  state = {
    hovering: false,
  };

  render() {
    const {
      collaboratePermissions,
      currentUserIsOwner,
      thumbnails,
      onRemoveCoverClick,
      videoId,
      disabled,
      hasPro,
      videoIsTeamShared,
    } = this.props;

    const { hovering } = this.state;

    const hasOgThumbnail = thumbnails[OG_THUMB_FULL];
    const editText = hasOgThumbnail ? 'Edit Thumbnail' : 'Remove Thumbnail';
    const editAction = hasOgThumbnail
      ? this.handleAddCoverClick
      : onRemoveCoverClick.bind(null, videoId);

    let button = null;

    if (hasPro) {
      button = thumbnails[THUMB_FULL] ? (
        <FabButton
          renderButtonChildren={this.renderActionDot}
          disabled={disabled}
          icon="thumbnail-wh"
          onClick={editAction}
        >
          {editText}
        </FabButton>
      ) : (
        <FabButton
          renderButtonChildren={this.renderActionDot}
          disabled={disabled}
          icon="thumbnail-wh"
          onClick={this.handleAddCoverClick}
        >
          Custom Thumbnail
        </FabButton>
      );
    } else {
      button = (
        <Fragment>
          <FabButton
            renderButtonChildren={this.renderActionDot}
            disabled={!hovering}
            onHover={this.startHovering}
            onBlur={this.endHovering}
            icon="thumbnail-wh"
            onClick={this.handleUpgradeNowClick}
          >
            {!hovering && 'Custom Thumbnail'}
            {hovering && (
              <span className="fab-button-upgrade-label">
                Upgrade
                <br />
                to Pro
              </span>
            )}
          </FabButton>
        </Fragment>
      );
    }

    return (
      (currentUserIsOwner ||
        videoIsTeamShared ||
        collaboratePermissions.write) &&
      !device.isMobile &&
      button
    );
  }

  handleUpgradeNowClick = () => {
    analytics.track(SHARE_PAGE_EDITOR_FAB_PRO_UPSELL, {
      fab_type: 'custom_thumbnail',
    });
    this.props.showUpgradeModal();
  };

  startHovering = () => this.setState({ hovering: true });
  endHovering = () => this.setState({ hovering: false });

  renderActionDot = () => {
    if (this.props.thumbnailTourIsActive) {
      return <ActionDot position={TOP_LEFT} />;
    }

    return null;
  };

  handleAddCoverClick = () => {
    analytics.track(CUSTOM_THUMBNAIL_CLICKED);
    this.props.startThumbnailFlow();
  };
}

const mapStateToProps = state => {
  const { currentTour, tourOpenAndActive } = state.featureTour;
  const { current: user } = state.user;

  const thumbnailTourIsActive =
    currentTour === HELP_UPLOAD_THUMBNAIL && tourOpenAndActive;

  return {
    currentUserIsOwner: state.share_video.current_user_is_owner,
    videoId: state.share_video.video.s3_id,
    canModifyThumbnail: state.user.capabilities.includes(CUSTOM_VIDEO_THUMBS),
    thumbnails: state.share_video.video.thumbnails,
    hasPro: user && user.capabilities[LOOM_PRO],
    thumbnailTourIsActive,
    videoIsTeamShared: state.share_video.video_is_team_shared,
    collaboratePermissions: state.share_video.video.collaboratePermissions,
  };
};

const mapDispatchToProps = dispatch => ({
  onRemoveCoverClick: videoId => dispatch(removeVideoThumbnail(videoId)),
  startThumbnailFlow: () => dispatch(startThumbnailFlow()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomThumbnailButton);
